import { TABS } from '../../shared/tabs.js';

export const TabSelector = ({ activeTab, onTabChange }) => (
  <div className="tabs-container">
    <div className="tabs" role="tablist">
      {TABS.map(tab => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`panel-${tab.id}`}
          className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </div>
);
